import React from "react";

export function ReportsArchive() {
    return (
        <>
        <center> 
			<br/>
            <br/>
            <br/>
            <br/>

            <br/>
        <h1 className="text-5xl md:text-5xl font-bold mb-6">Meeting Reports Archive</h1>

		<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>
2023 Meeting Reports
</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<br/>
</td>
<td valign="top">
<p>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2023/2023-01-11_fire_prevention_report.pdf" target="new">January 11, 2023</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2023/2023-02-08_fire_prevention_report.pdf" target="new">February 8, 2023</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2023/2023-03-08_fire_prevention_report.pdf" target="new">March 8, 2023</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2023/2023-04-12_fire_prevention_report.pdf" target="new">April 12, 2023</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2023/2023-05-10_fire_prevention_report.pdf" target="new">May 10, 2023</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2023/2022-06-14_fire_prevention_report.pdf" target="new">June 14, 2023</a><br/>
	
</p></td>
</tr>
</tbody>
</table>
	<p>&nbsp;</p>
	<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>
2022 Meeting Reports
</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<br/>
</td>
<td valign="top">
<p><a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-01-12_fire_prevention_report.pdf" target="new">January 12, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-02-09_fire_prevention_report.pdf" target="new">February 9, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-03-09_fire_prevention_report.pdf" target="new">March 9, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-04-13_fire_prevention_report.pdf" target="new">April 13, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-05-11_fire_prevention_report.pdf" target="new">May 11, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-06-08_fire_prevention_report.pdf" target="new">June 8, 2022</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-08-10_fire_prevention_report.pdf" target="new">July 13, 2022</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-08-10_fire_prevention_report.pdf" target="new">August 20, 2022</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-09-14_fire_prevention_report.pdf" target="new">September 14, 2022</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2022/2022-10-12_fire_prevention_report.pdf" target="new">October 12, 2022</a><br/>

</p></td>
</tr>
</tbody>
</table>
	<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>
2021 Meeting Reports
</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-02-10_chiefs_report.pdf" target="new">February 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-03-10_chiefs_report.pdf" target="new">March 10, 2021</a><br/>
</td>
<td valign="top">
<p><a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-01-13_fire_prevention_report.pdf" target="new">January 13, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-02-10_fire_prevention_report.pdf" target="new">February 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-03-10_fire_prevention_report.pdf" target="new">March 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-04-14_fire_prevention_report.pdf" target="new">April 14, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-05-12_fire_prevention_report.pdf" target="new">May 12, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-06-09_fire_prevention_report.pdf" target="new">June 9, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-07-14_fire_prevention_report.pdf" target="new">July 14, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-08-11_fire_prevention_report.pdf" target="new">August 11, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-09-08_fire_prevention_report.pdf" target="new">September 8, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-10-20_fire_prevention_report.pdf" target="new">October 20, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-11-10_fire_prevention_report.pdf" target="new">November 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2021/2021-12-08_fire_prevention_report.pdf" target="new">December 8, 2021</a>
</p></td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>
2020 Meeting Reports
</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-01-08_fire_chiefs_report.pdf" target="new">January 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-02-12_fire_chiefs_report.pdf" target="new">February 12, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-03-11_fire_chiefs_report.pdf" target="new">March 11, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-04-08_fire_chiefs_report.pdf" target="new">April 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-05-13_fire_chiefs_report.pdf" target="new">May 13, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-06-10_fire_chiefs_report.pdf" target="new">June 10, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-07-08_fire_chiefs_report.pdf" target="new">July 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-08-12_fire_chiefs_report.pdf" target="new">August 12, 2020</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-01-08_fire_prevention_report.docx">January 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-02-12_fire_prevention_report.docx">February 12, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-03-11_fire_prevention_report.docx">March 11, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-04-08_fire_prevention_report.pdf" target="new">April 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-05-13_fire_prevention_report.pdf" target="new">May 13, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-06-10_fire_prevention_report.pdf" target="new">June 10, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-07-08_fire_prevention_report.pdf" target="new">July 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-08-12_fire_prevention_report.pdf" target="new">August 12, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-09-09_fire_prevention_report.pdf" target="new">September 9, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-10-14_fire_prevention_report.pdf" target="new">October 14, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-11-11_fire_prevention_report.pdf" target="new">November 11, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2020/2020-12-09_fire_prevention_report.pdf" target="new">December 9, 2020</a></td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>
2019 Meeting Reports
</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-03-13_chiefs_report.pdf" target="new">March 13, 2019</a><br/>
	  <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-04-10_chiefs_report.pdf" target="new">April 10, 2019</a><br/>
	  <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-05-08_chiefs_report.pdf" target="new">May 8, 2019</a><br/>
	  <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-06-12_chiefs_report.pdf" target="new">June 12, 2019</a><br/>
	  <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-07-10_chiefs_report.pdf" target="new">July 10, 2019</a><br/>
	  <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-08-14_chiefs_report.pdf" target="new">August 14, 2019</a><br/>
	  <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-10-09_chiefs_report.pdf" target="new">October 9, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-11-13_chiefs_report.pdf" target="new">November 13, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-12-11_chiefs_report.pdf" target="new">December 11, 2019</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-01-09_fire_prevention_report.docx">January 9, 2019</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-02-13_fire_prevention_report.docx">February 13, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-03-13_fire_prevention_report.pdf" target="new">March 13, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-04-10_fire_prevention_report.pdf" target="new">April 10, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-05-08_fire_prevention_report.pdf" target="new">May 8, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-06-12_fire_prevention_report.pdf" target="new">June 12, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-07-10_fire_prevention_report.pdf" target="new">July 10, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-08-14_fire_prevention_report.pdf" target="new">August 14, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-09-11_fire_prevention_report.pdf" target="new">September 11, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-10-09_fire_prevention_report.pdf" target="new">October 9, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-11-13_fire_prevention_report.pdf" target="new">November 13, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2019/2019-12-11_fire_prevention_report.pdf" target="new">December 11, 2019</a>
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2018 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-01-10_chiefs_report.pdf" target="new">January 10, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-02-14_chiefs_report.pdf" target="new">February 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-03-14_chiefs_report.pdf" target="new">March 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-04-11_chiefs_report.pdf" target="new">April 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-05-09_chiefs_report.pdf" target="new">May 9, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-06-13_chiefs_report.pdf" target="new">June 13, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-07-11_chiefs_report.pdf" target="new">July 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-08-08_chiefs_report.pdf" target="new">August 8, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-09-12_chiefs_report.pdf" target="new">September 12, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-10-10_chiefs_report.pdf" target="new">October 10, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-11-14_chiefs_report.pdf" target="new">November 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-12-12_chiefs_report.pdf" target="new">December 12, 2018</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-01-10_fire_prevention_report.pdf" target="new">January 10, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-02-14_fire_prevention_report.pdf" target="new">February 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-03-14_fire_prevention_report.pdf" target="new">March 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-04-11_fire_prevention_report.pdf" target="new">April 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-05-09_fire_prevention_report.pdf" target="new">May 9, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-06-13_fire_prevention_report.pdf" target="new">June 13, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-07-11_fire_prevention_report.doc">July 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-08-08_fire_prevention_report.pdf" target="new">August 8, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-09-12_fire_prevention_report.doc">September 12, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-10-10_fire_prevention_report.doc">October 10, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-11-14_fire_prevention_report.docx">November 14, 2018</a> | <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2019_Projected_Budget.xlsx">2019 Projected Budget</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2018/2018-12-12_fire_prevention_report.doc">December 12, 2018</a>
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2017 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<p><a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-01-11_chiefs_report.pdf" target="new">January 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-02-08_chiefs_report.pdf" target="new">February 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-03-08_chiefs_report.pdf" target="new">March 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-04-12_chiefs_report.pdf" target="new">April 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-05-10_chiefs_report.pdf" target="new">May 10, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-06-12_chiefs_report.pdf" target="new">June 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-07-12_chiefs_report.pdf" target="new">July 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-08-09_chiefs_report.pdf" target="new">August 9, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-09-13_chiefs_report.pdf" target="new">September 13, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-10-11_chiefs_report.pdf" target="new">October 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-11-08_chiefs_report.pdf" target="new">November 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-12-13_chiefs_report.pdf" target="new">December 13, 2017</a>
</p>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-01-11_fire_prevention_report.pdf" target="new">January 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-02-08_fire_prevention_report.pdf" target="new">February 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-03-08_fire_prevention_report.docx">March 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-04-12_fire_prevention_report.pdf" target="new">April 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-05-10_fire_prevention_report.pdf" target="new">May 10, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-06-12_fire_prevention_report.pdf" target="new">June 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-07-12_fire_prevention_report.pdf" target="new">July 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-08-09_fire_prevention_report.pdf" target="new">August 9, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-09-13_fire_prevention_report.pdf" target="new">September 13, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-10-11_fire_prevention_report.pdf" target="new">October 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-11-08_fire_prevention_report.pdf" target="new">November 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2017/2017-12-13_fire_prevention_report.pdf" target="new">December 13, 2017</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2016 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-01-13_Chiefs_report.pdf" target="new">January 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-02-10_Chiefs_report.pdf" target="new">February 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-03-09_Chiefs_report.pdf" target="new">March 9, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-04-13_Chiefs_report.pdf" target="new">April 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-05-16_Chiefs_report.pdf" target="new">May 16, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-06-08_Chiefs_report.pdf" target="new">June 8, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-07-13_Chiefs_report.pdf" target="new">July 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-08-10_Chiefs_report.pdf" target="new">August 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-10-04_Chiefs_report.pdf" target="new">October 4, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-11-09_Chiefs_report.pdf" target="new">November 9, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-12-14_Chiefs_report.pdf" target="new">December 14, 2016</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-01-13_fire_prevention_report.pdf" target="new">January 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-02-10_fire_prevention_report.pdf" target="new">February 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-03-09_fire_prevention_report.pdf" target="new">March 9, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-04-13_fire_prevention_report.pdf" target="new">April 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-05-16_fire_prevention_report.pdf" target="new">May 16, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-06-08_fire_prevention_report.pdf" target="new">June 8, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-07-13_fire_prevention_report.pdf" target="new">July 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-08-10_fire_prevention_report.pdf" target="new">August 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-09-14_fire_prevention_report.docx">September 14, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-10-04_fire_prevention_report.pdf" target="new">October 4, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-11-09_fire_prevention_report.pdf" target="new">November 9, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2016/2016-12-14_fire_prevention_report.pdf" target="new">December 14, 2016</a>
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2015 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2015/2015-01-21_fire_prevention_report.pdf" target="new">January 21, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2015/2015-03-18_fire_prevention_report.pdf" target="new">March 18, 2015</a>
</td>
<td valgin="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2015/2015-01-21_Fire_Prevention_report.pdf" target="new">January 21, 2015 </a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2015/20150218_Com_meeting.doc">February 18, 2015</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2015/2015-03-18_fire_prevention_report.pdf" target="new">March 18, 2015</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2015/2015-05-20_Fire_Prev_report.pdf" target="new">May 20, 2015</a>
    </td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2014 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-01-15_chief_report.pdf" target="new">January 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-02-19_chief_report.pdf" target="new">February 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-03-19_chief_report.pdf" target="new">March 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-04-16_chief_report.pdf" target="new">April 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-05-21_chief_report.pdf" target="new">May 21, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-07-16_chief_report.pdf" target="new">July 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-08-20_chief_report.pdf" target="new">August 08, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-09-17_chief_report.pdf" target="new">September 17, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-10-15_chief_report.pdf" target="new">October 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-11-19_chief_report.pdf" target="new">November 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-12-17_chief_report.pdf" target="new">December 17, 2014</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-01-15_fire_prevention_report.pdf" target="new">January 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-02-19_fire_prevention_report.pdf" target="new">February 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-03-19_fire_prevention_report.pdf" target="new">March 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-04-16_fire_prevention_report.pdf" target="new">April 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-05-21_fire_prevention_report.pdf" target="new">May 21, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-06-18_fire_prevention_report.pdf" target="new">June 18, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-07-16_fire_prevention_report.pdf" target="new">July 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-08-20_fire_prevention_report.pdf" target="new">August 08, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-09-17_fire_prevention_report.pdf" target="new">September 17, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-10-15_fire_prevention_report.pdf" target="new">October 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-11-19_fire_prevention_report.pdf" target="new">November 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2014/2014-12-17_fire_prevention_report.pdf" target="new">December 17, 2014</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2013 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-05-15_chief_report.pdf" target="new">May 15, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-06-19_chief_report.pdf" target="new">June 19, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-08-21_chief_report.pdf" target="new">August 21, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-09-18_chief_report.pdf" target="new">September 18, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-10-16_chief_report.pdf" target="new">October 16, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-12-18_chief_report.pdf" target="new">December 18, 2013</a>
</td>
<td valgin="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-01-16_fire_prevention_report.pdf" target="new">January 16, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-02-20_fire_prevention_report.pdf" target="new">February 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-03-20_fire_prevention_report.pdf" target="new">March 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-04-17_fire_prevention_report.doc">April 17, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-05-15_fire_prevention_report.pdf" target="new">May 15, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-06-19_fire_prevention_report.pdf" target="new">June 19, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-07-17_fire_prevention_report.pdf" target="new">July 17, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-08-21_fire_prevention_report.pdf" target="new">August 21, 2013</a><br/>

<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-09-18_fire_prevention_report.pdf" target="new">September 18, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-10-16_fire_prevention_report.pdf" target="new">October 16, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-11-20_fire_prevention_report.pdf" target="new">November 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2013/2013-12-18_fire_prevention_report.pdf" target="new">December 18, 2013</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2012 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
</td>
<td valgin="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012_DCA_fire_prevention_audit.pdf">2012 DCA Fire Prevention Audit</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-01-18_fire_prevention_report.pdf" target="new">January 18, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-02-15_fire_prevention_report.pdf" target="new">February 15, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-03-21_fire_prevention_report.pdf" target="new">March 21, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-04-18_fire_prevention_report.pdf" target="new">April 18, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-05-16_fire_prevention_report.pdf" target="new">May 16, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-06-20_fire_prevention_report.pdf" target="new">June 20, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-07-12_fire_prevention_report.pdf" target="new">July 12, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-08-15_fire_prevention_report.pdf" target="new">August 15, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-09-19_fire_prevention_report.pdf" target="new">September 19, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-10-17_fire_prevention_report.pdf" target="new">October 17, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-11-21_fire_prevention_report.pdf" target="new">November 21, 2012</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Reports/2012/2012-12-12_fire_prevention_report.pdf" target="new">December 12, 2012</a>
    </td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><strong><center>2011 Meeting Reports</center></strong></u>
</td>
</tr>
<tr>
<td>
<u>Chief's Reports</u>
</td>
<td>
<u>Fire Prevention Reports</u>
</td>
</tr>
<tr>
<td valign="top">
</td>
<td valgin="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Reports/2011/2011-12-14_fire_prevention_report.pdf" target="new">December 14, 2011</a>
</td>
</tr>
</tbody></table>
<p></p>

</center>
        </>
    )
}